import { useApiQuery } from '@/api/main/query'
import { PaginatedCollection } from '@/api/types'
import { TableTemplate } from '@/features/baseTable'
import { CardTableSkeleton } from '@/features/baseTable/ui/CardTableSkeleton'
import { BaseCard } from '@/shared/components'
import { FilterButton } from '@/shared/components/FilterButton/FilterButton'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { dashboardMerchantApi } from '../../api'
import { TopupStatistic } from '../../model'
import { payoutColumns } from './model'

const payputFilterButtons: FilterButtonModel[] = [
  { name: 'Ожидают', label: 'waiting', index: 1 },
  { name: 'Оплаченные', label: 'paid', index: 2 },
  { name: 'Отмененные', label: 'canceled', index: 3 },
  { name: 'Спорные', label: 'disput', index: 4 },
  { name: 'Возвращенные', label: 'returned', index: 5 },
]

export const TopupsTableCard = () => {
  const [selected, setSelected] = useState(1)

  const { data, isLoading, error } = useApiQuery<PaginatedCollection<TopupStatistic[]>>(
    ['topups-dashboard', selected],
    dashboardMerchantApi.topups,
    {
      status: selected,
      limit: 10,
    }
  )

  return (
    <BaseCard className="w-full" variant="secondary" radius="lg">
      <div className="flex justify-between items-center mb-4 md:mb-6">
        <h3>Входящие заявки</h3>
        <Link to="/deals" className="text-primary dark:text-primary-dark text-sm">
          Показать все
        </Link>
      </div>
      <div className="flex gap-0.5 mb-5 p-0.5 overflow-x-auto scrollbar-hide">
        {payputFilterButtons.map((b) => (
          <FilterButton
            key={b.index}
            name={b.name}
            onClick={() => setSelected(b.index)}
            selected={b.index === selected}
            padding="sm"
          />
        ))}
      </div>
      {error ? (
        <p>Ошибка загрузки данных.</p>
      ) : isLoading ? (
        <CardTableSkeleton />
      ) : !data?.items || data.items?.length === 0 ? (
        <p>Данных нет.</p>
      ) : (
        <TableTemplate columns={payoutColumns} data={data.items} />
      )}
    </BaseCard>
  )
}
